<template>
    <div class="cms-view">
        <transition name="fade" mode="out-in">
            <MainHero v-if="[orderProcess.STEPS.NO_ORDER_ONGOING, orderProcess.STEPS.ORDER_COMPLETED].includes(currentOrderProcessStep)"></MainHero>
            <CheckoutHero
                    v-else-if="![viewports.MOBILE.name, viewports.TABLET.name].includes(currentViewport)"></CheckoutHero>
        </transition>
        <!-- <Steps class="is-desktop-only"/> -->
        <transition name="fade">
            <div class="cms-view__content" v-if="$route.path !== '/' && $route.path !== '/en/start' && $route.path !== '/en' && pageContent">
                <template v-for="element in pageContent">
                    <CMSViewComponent :key="'cms_content_element_' + element.id" :element="element"/>
                </template>
            </div><div class="my-6 cms-view__content" v-else><MeltwerkLegacyContent></MeltwerkLegacyContent></div>
        </transition>
        <ContactForm v-if="$route.path === '/kontakt'"/>
    </div>
</template>

<script>
    import MainHero from "./layout/MainHero";
    import Steps from "./layout/Steps";
    import CMSViewComponent from "./cms-content-types/CMSViewComponent";
    import CheckoutHero from "./checkout/CheckoutHero";
    import {componentMapping} from "../store/constants/component-mapping";
    import {orderProcess} from "../store/constants/order-process";
    import {viewports} from "../store/constants/viewports";
    import {mapGetters} from "vuex";
    import ContactForm from "./Forms/ContactForm";
    import MeltwerkLegacyContent from "./layout/MeltwerkLegacyContent";

    export default {
        name: 'CMSView',
        components: {
          MeltwerkLegacyContent,
            ContactForm,
            CheckoutHero,
            CMSViewComponent,
            Steps,
            MainHero,
        },
        data() {
            return {
                componentMapping,
                orderProcess,
                viewports
            }
        },
        computed: {
            ...mapGetters(['currentOrderProcessStep', 'currentViewport']),
            cmsPage() {
                return this.$store.getters.cmsPage;
            },
            pageContent() {
                return this.cmsPage.content ? this.cmsPage.content.colPos0 : null;
            }
        },
        methods: {
            fetchCMSData() {
                this.$store.dispatch('fetchCMSPage', {urlSlug: this.$route.path}).catch(() => {
                    this.$router.push('/not-available');
                });
            }
        },
        watch: {
            $route() {
                this.fetchCMSData();
            }
        },
        created() {
            this.fetchCMSData()
        }
    }
</script>
